export default function ArrowDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      fill="none"
      viewBox="0 0 16 10"
    >
      <path
        fill="#677484"
        d="M8.664 8.664c-.39.39-.976.39-1.328 0l-6.25-6.25a.855.855 0 0 1 0-1.289.855.855 0 0 1 1.289 0l5.586 5.586 5.625-5.625a.92.92 0 0 1 1.289 0c.39.39.39.976 0 1.328l-6.21 6.25Z"
      />
    </svg>
  )
}
